export const initializeIntercom = (user, intercom) => {
  try {
    if (!user || !intercom) {
      console.warn(
        "Cannot initialize Intercom: missing user or intercom service",
      );
      return;
    }

    intercom.init({
      id: user?.id,
      name: user?.first_name + " " + user?.last_name,
      email: user?.email,
      createdAt: user.created_at,
    });
  } catch (error) {
    console.error("An error occurred while initializing intercom: ", error);
  }
};
